import { render, staticRenderFns } from "./NotificationOrders.vue?vue&type=template&id=20071924&scoped=true&"
import script from "./NotificationOrders.vue?vue&type=script&lang=js&"
export * from "./NotificationOrders.vue?vue&type=script&lang=js&"
import style0 from "./NotificationOrders.vue?vue&type=style&index=0&id=20071924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20071924",
  null
  
)

export default component.exports